import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { computed } from "vue";
import { useDonation } from "../../context/donationContext";
import { useChrome } from "../../i18n/useChrome";
import SegmentedControl from "../ui/SegmentedControl.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'FrequencySelector',
    setup(__props) {
        // SYNC: see ../../_SYNC.md.
        const { frequencyOptions, frequency, setFrequency } = useDonation();
        const { tf } = useChrome();
        const options = computed(() => frequencyOptions.value.map((o) => ({
            value: o.value,
            label: tf(`frequency.${o.value}`),
        })));
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(SegmentedControl, {
                options: options.value,
                "model-value": _unref(frequency),
                label: _unref(tf)('amount.frequencyLabel'),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = (v) => _unref(setFrequency)(v))
            }, null, 8 /* PROPS */, ["options", "model-value", "label"]));
        };
    }
});
